import { clientAppLog } from '@/app/components/search/logging/clientAppLog.ts';
import { handleChunkLoadError } from '@/utils/errors.ts';
import { sendMetricIncrement } from '@/app/components/hotel-detail/metrics.ts';

const ERRORS_WITH_LEVEL_WARNING = [
  'Loading chunk',
  // add here other handled error messages that should be logged as warnings
];

export const logFromErrorBoundary = (
  error: Error,
  id: string,
  stackTraceEnabled: boolean,
  componentStack?: string | null
) => {
  const isWarning = ERRORS_WITH_LEVEL_WARNING.some((err) => error?.message.includes(err));
  const stackTrace = error?.stack?.replace(/\n/g, ' || ') || 'No stack trace';
  const fullComponentStack = componentStack?.replace(/\n/g, ' || ') || 'No component stack';

  const detailedLogMessage = [
    `ErrorBoundary:${id}`,
    `error:${error?.name}`,
    `message:${error?.message}`,
    ...(stackTraceEnabled ? [`stackTrace:${stackTrace}`, `componentStack:${fullComponentStack}`] : []),
  ].join(' | ');

  clientAppLog({
    level: isWarning ? 'WARN' : 'ERROR',
    codeSourceName: `ErrorBoundary:${id}`,
    logMessage: detailedLogMessage,
    url: window?.location?.href,
  });

  if (isWarning) {
    handleChunkLoadError(error);
  }

  sendMetricIncrement(`app.js-error.error-boundary.${id}.triggered`);
};
